import React from 'react';
import solutionIcon1 from '../../assets/imgs/naverSolution1.svg';
import solutionIconLine1 from '../../assets/imgs/naverSolutionLine1.svg';
import solutionIcon2 from '../../assets/imgs/naverSolution2.svg';
import solutionIconLine2 from '../../assets/imgs/naverSolutionLine2.svg';
import solutionIcon3 from '../../assets/imgs/naverSolution3.svg';
import solutionIconLine3 from '../../assets/imgs/naverSolutionLine3.svg';
import solutionIcon4 from '../../assets/imgs/naverSolution4.svg';
import solutionIconLine4 from '../../assets/imgs/naverSolutionLine4.svg';
import solutionIcon5 from '../../assets/imgs/naverSolution5.svg';
import solutionIconLine5 from '../../assets/imgs/naverSolutionLine5.svg';
import solutionIcon6 from '../../assets/imgs/naverSolution6.svg';
import solutionIconLine6 from '../../assets/imgs/naverSolutionLine6.svg';

const solutionData = [
  {
    key: 'naverSmartWork',
    title: `스마트워크 특화
    클라우드 솔루션`,
    enTitle: `Smart
  Work
  Cloud Solutions`,
    titleColor: '#08794B',
    themeColor: '#31E89F',
    icon: solutionIcon1,
    lineIcon: solutionIconLine1,
    contentTitle:
      '협업툴과 업무 자동화를 통한 효율적인 디지털 업무 환경을 제공합니다.',
    contentData: [
      '네이버웍스(NAVER WORKS)와 같은 협업 툴 연동 지원',
      '업무 프로세스 자동화를 위한 그룹웨어·메일·메신저 통합 관리 가능',
    ],
  },
  {
    key: 'naverAi',
    title: `AI 데이터 분석 특
    클라우드 솔루션`,
    enTitle: `AI Data Solutions`,
    titleColor: '#3E8E7B',
    themeColor: '#28464E',
    icon: solutionIcon2,
    lineIcon: solutionIconLine2,
    contentTitle:
      '클로바 AI 및 빅데이터 분석 플랫폼을 활용한 지능형 서비스 인프라를 제공합니다.',
    contentData: [
      '네이버의 자체 AI(클로바) API를 통한 음성인식·OCR·챗봇 구축 가능',
      '빅데이터 분석(Hadoop, Spark)을 위한 데이터 레이크 및 분석 환경 제공',
    ],
  },
  {
    key: 'naverGlobal',
    title: `글로벌 서비스 특화 
    클라우드 솔루션`,
    enTitle: `Global Service Solutions`,
    titleColor: '#4C93FF',
    themeColor: '#31E89F',
    icon: solutionIcon3,
    lineIcon: solutionIconLine3,
    contentTitle:
      '글로벌 확장과 해외 시장 진출을 위한 최적의 클라우드 인프라를 지원합니다.',
    contentData: [
      '일본, 싱가포르, 독일 등 글로벌 리전 기반 멀티리전 구축 가능',
      '글로벌 CDN과 DNS 서비스로 빠른 해외 서비스 대응 지원',
    ],
  },
  {
    key: 'naverMedia',
    title: `영상 미디어 특화
    클라우드 솔루션`,
    enTitle: `Vod & Media Solutions`,
    titleColor: '#0199FF',
    themeColor: '#4B98F9',
    icon: solutionIcon4,
    lineIcon: solutionIconLine4,
    contentTitle:
      '고품질 라이브 스트리밍, VOD 및 미디어 서비스에 최적화된 환경을 제공합니다.',
    contentData: [
      '실시간 영상 트랜스코딩 및 고해상도 영상 스트리밍 지원',
      '라이브 이벤트 트래픽 폭증 대비 오토스케일링 구성 제공',
    ],
  },
  {
    key: 'naverDevOps',
    title: `DevOps & 자동화 
    특화 클라우드 솔루션`,
    enTitle: `DevOps Aotomation Solutions`,
    titleColor: '#464646',
    themeColor: '#4A4A4A',
    icon: solutionIcon5,
    lineIcon: solutionIconLine5,
    contentTitle:
      '개발부터 배포, 운영까지 전 과정을 자동화하는 DevOps 환경을 제공합니다.',
    contentData: [
      '클라우드 기반 CI/CD 파이프라인 및 자동 배포 환경 구축 가능',
      'GitHub, Jenkins 등 주요 도구와의 연동 지원',
    ],
  },

  {
    key: 'public',
    title: `공공기관 특화 
    클라우드 솔루션`,
    enTitle: `Public Institution Solutions`,
    titleColor: '#358AAD',
    themeColor: '#43A3AB',
    icon: solutionIcon6,
    lineIcon: solutionIconLine6,
    contentTitle:
      '공공기관의 보안 및 규제 요건을 충족하는 전용 클라우드 환경을 제공합니다.',
    contentData: [
      'CSAP 인증을 획득하여 공공기관 보안 기준 완벽 충족',
      '행정망 연계, 망분리, 온프레미스 연동이 가능한 하이브리드 클라우드 지원',
    ],
  },
];
const NaverModalContents = ({ solutionActiveIndex }) => {
  return (
    <div className="modalWrap naverModalContent">
      <div className="flex-col gap-16 serviceDescription">
        <div
          style={{
            backgroundColor: solutionData[solutionActiveIndex].themeColor,
          }}
          className="colorBox flex-col  align-end justify-between"
        >
          <div className="titleWrap">
            <span>{solutionData[solutionActiveIndex].enTitle}</span>
          </div>
          <div className="iconWrap">
            <img src={solutionData[solutionActiveIndex].lineIcon} alt="" />
          </div>
        </div>
        <div className="contentsBox px-24 flex-full gap-32 py-32 flex-col">
          <div className="contentTitle">
            <span> {solutionData[solutionActiveIndex].contentTitle}</span>
          </div>
          <div className="divide "></div>
          <div className="contentsList flex-col gap-32">
            {solutionData[solutionActiveIndex].contentData.map((item, i) => {
              return (
                <div className={'flex-row align-center gap-24'}>
                  <div className={`contentNum`}>
                    <span>0{i + 1}</span>
                  </div>
                  <div className="content">
                    <span>{item}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

NaverModalContents.headerTitle = 'ddd';

export default NaverModalContents;
